// extracted by mini-css-extract-plugin
module.exports = {"slide":"SlideImageText_slide__ihlHo","slide__image":"SlideImageText_slide__image__v5WxI"};